import styled from '@emotion/styled';

export const Wrapper = styled.div`
    margin: auto;
    padding: 2rem;
    text-align: center;
`;
